module.exports = __webpack_public_path__ + "fonts/4b70e9c611b5baeff1409c15a41f28c1.svg";